module.exports = __webpack_public_path__ + "static/img/image@2x.b58cccee.png";